<script setup lang="ts">
import type { NuxtError } from "#app"

const { error } = defineProps<{ error: NuxtError }>()
watch(
  () => error,
  () => {
    // eslint-disable-next-line no-console
    console.error(error)
  },
  { immediate: true },
)

const handleError = () => clearError({ redirect: "/" })
</script>
<template>
  <NuxtLayout name="unauthenticated">
    <template #heading>
      <TypographyHeading>
        {{ $t("error.title") }}
      </TypographyHeading>
      <p class="mt-1 text-sm/5 text-zinc-600">
        {{ $t("error.text") }}
      </p>
    </template>
    <div class="px-6 sm:p-10">
      <LocalisedAlert :error />
      <FormButton variant="black" class="mt-4 w-full" @click="handleError">
        {{ $t("error.button") }}
      </FormButton>
    </div>
  </NuxtLayout>
</template>
